import React, { FC } from 'react';
import { Box, Typography, Button } from '@mui/material';

interface NoDataFoundProps {
  title?: string;
  message?: string;
  onClearResults?: () => void;
  onResetFilters?: () => void;
  clearButtonText?: string;
  resetButtonText?: string;
  showClearButton?: boolean;
  showResetButton?: boolean;
}

export const NoDataFound: FC<NoDataFoundProps> = ({
  title = "No Data Available",
  message = "No data was found for the selected criteria. Please try adjusting your filters or selecting a different date range.",
  onClearResults,
  onResetFilters,
  clearButtonText = "Clear Results",
  resetButtonText = "Reset Filters",
  showClearButton = true,
  showResetButton = true
}) => {
  return (
    <Box 
      sx={{ 
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '200px',
        backgroundColor: '#f8f9fa',
        borderRadius: '8px',
        border: '1px solid #e1e8ed',
        mt: 3,
        p: 4,
        textAlign: 'center'
      }}
    >
      <Typography 
        variant="h6" 
        sx={{ 
          color: '#063142',
          fontWeight: 600,
          mb: 2
        }}
      >
        {title}
      </Typography>
      <Typography 
        variant="body1" 
        sx={{ 
          color: '#666',
          mb: 3,
          maxWidth: '500px'
        }}
      >
        {message}
      </Typography>
      <Box sx={{ display: 'flex', gap: 2 }}>
        {showClearButton && onClearResults && (
          <Button
            variant="outlined"
            onClick={onClearResults}
            sx={{
              borderColor: '#00B6BA',
              color: '#00B6BA',
              '&:hover': {
                borderColor: '#009499',
                backgroundColor: '#f0fffe'
              }
            }}
          >
            {clearButtonText}
          </Button>
        )}
        {showResetButton && onResetFilters && (
          <Button
            variant="contained"
            onClick={onResetFilters}
            sx={{
              backgroundColor: '#00B6BA',
              '&:hover': {
                backgroundColor: '#009499'
              }
            }}
          >
            {resetButtonText}
          </Button>
        )}
      </Box>
    </Box>
  );
}; 